import Vue from 'vue'
import Vuex from 'vuex'
import {setupVerticalNavMenu} from '@hw-ui/layouts/components/navigation/menu-vertical/useVerticalNavMenu'

// Modules
import hwUiLayout from '@hw-ui/store/layout'
import hwUiMenu from '@hw-ui/store/menu'

import app from './app'
import appAuth from './auth'
import appAccount from './account'
import application from './application'

Vue.use(Vuex)

const rootModule = {
  state: {
  },
  getters: {
    userRole: (state, getters, rootState, rootGetters) => value => rootGetters['appAccount/userRole'](value),
  },
  actions: {
    updateLayoutAndMenu: {
      root: true,
      handler(namespacedContext, payload) {
        const { layout } = payload
        namespacedContext.commit('hwUiMenu/SET_ACTIVE_MENU_ITEMS', {app: payload.app, layout})
        namespacedContext.commit('hwUiLayout/UPDATE_LAYOUT_TYPE', layout)
      }
    }
  }
}

const store = new Vuex.Store({
  modules: {
    app, // TODO better name
    appAuth,
    appAccount,
    application,
    // TODO move to 1 hw-ui and dynamic reg it
    hwUiLayout,
    hwUiMenu,
    root: rootModule
  },
  strict: process.env.DEV,
})

setupVerticalNavMenu(store, 'hwUiMenu') // TODO should not need this line

export default store
